export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11472.a87d4b0d.jpg";